// Models
import { useStores } from 'models'

// React
import { useCallback } from 'react'

// Interfaces
import {
  IContactUsGetAttrs,
  IContactUsUpdateAttrs,
} from 'interfaces/back-office/content-management/contact-us/contact-us/contact-us-view.intercace'

const useContactUs = () => {
  // Hook
  const {
    contactUs: {
      contactUs_isLoading,
      contactUs_isSaveLoading,
      contactUs_detail,
      contactUs_CLEAR_DETAIL,
      contactUs_fetch: contactUsFetch,
      contactUs_update: contactUsUpdate,
    },
  } = useStores()

  /**
   * @description Fetch contact us
   *
   * @param {IContactUsGetAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const contactUs_fetch = useCallback(
    async (payload: IContactUsGetAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        contactUsFetch({
          body: { ...payload.body },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    // eslint-disable-next-line
    [],
  )

  /**
   * @description Update contact us
   *
   * @param {IContactUsUpdateAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const contactUs_update = useCallback(
    async (payload: IContactUsUpdateAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        contactUsUpdate({
          body: { ...payload.body },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    // eslint-disable-next-line
    [],
  )

  return {
    contactUs_isLoading,
    contactUs_isSaveLoading,
    contactUs_detail,
    contactUs_CLEAR_DETAIL,
    contactUs_fetch,
    contactUs_update,
  }
}

export { useContactUs }
